import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import firebase from '../../Firebase';
import history from '../../../history';
import AdminShell from '../layout/AdminShell';
import Card from '../ui/Card';
import AvatarCircle from '../ui/AvatarCircle';
import { TextField } from '../ui/FormField';
import { UserIcon, EyeIcon, LogoutIcon } from '../ui/icons';

// Redesign of newadmin/User.js. The original profile/password forms were
// display-only (inputs with no handlers, dead Save buttons) — kept as
// explicitly read-only fields, same non-behavior.
const MENU_ITEMS = [
    { key: 'profile', label: 'Profile Overview', icon: UserIcon },
    { key: 'password', label: 'Change Password', icon: EyeIcon },
];

const UserSettingsPage = () => {
    const user = useSelector((s) => s.user);
    const [menu, setMenu] = useState('profile');

    const signOut = () => {
        firebase
            .auth()
            .signOut()
            .then(() => {
                history.push('/login');
            });
    };

    return (
        <AdminShell title="User" maxWidth="max-w-5xl">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 items-start">
                <Card className="lg:col-span-1" bodyClassName="p-4 sm:p-5">
                    <div className="flex items-center gap-3 px-2 py-2">
                        <AvatarCircle name={user.name} size="lg" />
                        <div className="min-w-0">
                            <p className="text-sm font-bold text-[#1F2937] truncate">{user.name}</p>
                            <p className="text-xs text-[#6B7280] truncate">{user.email}</p>
                        </div>
                    </div>

                    <nav className="mt-4 space-y-1">
                        {MENU_ITEMS.map((item) => {
                            const active = menu === item.key;
                            const Icon = item.icon;
                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => setMenu(item.key)}
                                    className="w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-semibold transition-colors"
                                    style={
                                        active
                                            ? { backgroundColor: '#EFEAFE', color: '#5B3FE0' }
                                            : { color: '#6B7280' }
                                    }
                                >
                                    <Icon className="h-5 w-5" />
                                    {item.label}
                                </button>
                            );
                        })}
                        <button
                            type="button"
                            onClick={signOut}
                            className="w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-semibold text-[#DC2626] hover:bg-[#FEE2E2] transition-colors"
                        >
                            <LogoutIcon className="h-5 w-5" />
                            Sign Out
                        </button>
                    </nav>
                </Card>

                <div className="lg:col-span-2">
                    {menu === 'profile' ? (
                        <Card title="Profile Overview" subtitle="Your account details">
                            <div className="space-y-4 max-w-md">
                                <TextField label="Name" value={user.name || ''} disabled readOnly />
                                <TextField label="Email Address" value={user.email || ''} disabled readOnly />
                            </div>
                        </Card>
                    ) : (
                        <Card title="Change Password" subtitle="Password changes are managed by your administrator">
                            <div className="space-y-4 max-w-md">
                                <TextField label="Current Password" type="password" value="" disabled readOnly />
                                <TextField label="New Password" type="password" value="" disabled readOnly />
                                <TextField label="Verify Password" type="password" value="" disabled readOnly />
                            </div>
                        </Card>
                    )}
                </div>
            </div>
        </AdminShell>
    );
};

export default UserSettingsPage;
